/**
 * 要素がクリッカブルかどうかを判定する
 *
 * @param element 判定対象のHTMLElement
 * @returns クリッカブルな要素の場合はtrue
 */
const isClickableElement = (element: HTMLElement): boolean => {
  const tagName = element.tagName.toLowerCase();

  // 基本的なクリッカブルタグ
  if (tagName === 'a' || tagName === 'button') {
    return true;
  }

  // フォーム要素による判定
  if (tagName === 'input' || tagName === 'select' || tagName === 'textarea' || tagName === 'label') {
    return true;
  }

  // 対話的なHTML5要素
  if (tagName === 'details' || tagName === 'summary') {
    return true;
  }

  // ロール属性による判定（インタラクティブなrole）
  const role = element.getAttribute('role');
  if (role === 'button' || role === 'checkbox' || role === 'radio' || role === 'switch' || role === 'link' || role === 'tab' || role === 'menuitem') {
    return true;
  }

  // イベント属性による判定
  return element.hasAttribute('onclick') || element.hasAttribute('href');
};

/**
 * クリックイベントのターゲット要素またはその祖先要素にクリッカブルな要素が含まれているかを判定する
 *
 * この関数は行クリックイベントとセル内のクリッカブル要素のイベントが競合しないようにするために使用されます。
 * セル内にリンクやボタンがある場合、それらのクリックが行クリックより優先されるべきです。
 *
 * @param target クリックイベントのターゲット要素
 * @param currentTarget クリックイベントのcurrentTarget（探索を停止する要素）
 * @returns クリッカブルな要素が見つかった場合はtrue
 */
export const hasClickableAncestor = (target: HTMLElement, currentTarget: EventTarget | null): boolean => {
  let currentElement: HTMLElement | null = target;
  while (currentElement && currentElement !== currentTarget) {
    if (isClickableElement(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
};